<script setup lang="ts">
import {
  SoccerEventStatusId,
  SoccerIncidentId,
} from '@collector/sportsapi-client-legacy'
import BetButton from '@desktop/views/Relation/Sports/components/RelationView/Main/PocketIncidents/BetButton/BetButton.vue'

const disabledStatuses = new Set([
  SoccerEventStatusId.NotStarted,
  SoccerEventStatusId.StartDelayed,
  SoccerEventStatusId.Postponed,
  SoccerEventStatusId.Abandoned,
  SoccerEventStatusId.Cancelled,
])
</script>

<template>
  <BetButton
    class="min-w-36"
    betMarketEventKey="bet_corners"
    betStatusActiveText="Close corners"
    betStatusInactiveText="Open corners"
    :openMarketsIncidentId="SoccerIncidentId.CornerMarketsEnabled"
    :closeMarketsIncidentId="SoccerIncidentId.CornerMarketsDisabled"
    :disabledStatuses
  >
    <img
      class="h-3.5 w-3.5"
      src="./corner.svg"
    />
  </BetButton>
</template>
